import apiFetch from '../apiFetch'

export default function (token, purchasePresentTypeId) {
  return apiFetch({ endPoint: `PurchasePresentTypes/${purchasePresentTypeId}/Recover`, method: 'PUT', token: token })
}
